import { getBEDEV2ServiceBasePath } from '@modules/utilities/constants/baseUrl';
import mapMemoizeSingleParamFunction from '@modules/utilities/utils/mapMemoizeSingleParamFunction';

export enum UserIdParameters {
  EnableCourses = 'enableCourses',
}

export type UserIdParameterResults = {
  [UserIdParameters.EnableCourses]: boolean | null;
};

export enum CreatorDashboardParameters {
  EnableModerationModal = 'enableModerationModal',
}

export type CreatorDashboardParameterResults = {
  [CreatorDashboardParameters.EnableModerationModal]: boolean | null;
};

export enum IxpLayers {
  UserId = 'CreatorHub.CreatorDocumentation.UserId',
  CreatorDashboard = 'CreatorDashboard',
  CreatorHubNavigationUser = 'CreatorHub.Navigation.User',
  EngineReference = 'CreatorHub.CreatorDocumentation.EngineReference',
}

enum CreatorHubNavigationUserParameters {
  EnableIAM2 = 'enableIAM2',
}

enum EngineReferenceParameters {
  EnableEngineReference = 'enableReferenceRevamp2025Q4',
}

export type CreatorHubNavigationUserParameterResults = {
  [CreatorHubNavigationUserParameters.EnableIAM2]: boolean | null;
};

export type EngineReferenceParameterResults = {
  [EngineReferenceParameters.EnableEngineReference]: boolean | null;
};

type IxpParamEnum = Record<string, string>;
export const IxpParameters: Record<IxpLayers, IxpParamEnum> = {
  [IxpLayers.UserId]: UserIdParameters,
  [IxpLayers.CreatorDashboard]: CreatorDashboardParameters,
  [IxpLayers.CreatorHubNavigationUser]: CreatorHubNavigationUserParameters,
  [IxpLayers.EngineReference]: EngineReferenceParameters,
};

export type TIxpParameterResults = {
  [IxpLayers.UserId]: UserIdParameterResults;
  [IxpLayers.CreatorDashboard]: CreatorDashboardParameterResults;
  [IxpLayers.CreatorHubNavigationUser]: CreatorHubNavigationUserParameterResults;
  [IxpLayers.EngineReference]: EngineReferenceParameterResults;
};

async function fetchIxpParametersUncached<Layer extends IxpLayers>(
  layer: Layer,
): Promise<TIxpParameterResults[Layer]> {
  const baseURL = getBEDEV2ServiceBasePath('product-experimentation-platform');
  const paramList = Object.values(IxpParameters[layer]).join(',');
  const url = `${baseURL}/v1/projects/1/layers/${layer}/values?parameters=${paramList}`;
  const response = await fetch(url, {
    credentials: 'include',
  });
  return response.json();
}

export const fetchIxpParameters = mapMemoizeSingleParamFunction(fetchIxpParametersUncached);
